'use strict';

var API_v1alpha1_schema = require('../schema/kinds/API.v1alpha1.schema.json.cjs.js');
var util = require('./util.cjs.js');

const apiEntityV1alpha1Validator = util.ajvCompiledJsonSchemaValidator(API_v1alpha1_schema.default);

exports.apiEntityV1alpha1Validator = apiEntityV1alpha1Validator;
//# sourceMappingURL=ApiEntityV1alpha1.cjs.js.map
